import React, { Component } from "react";
import axios from "axios";
import { Layout, Collapse, Form } from "antd";
import moment from "moment";
import PropTypes from "prop-types";

import {
  Walkthrough,
  ButtonViews,
  ButtonViewTypes,
  Selector,
  SelectorDuid,
  //Footer,
  RequestError,
  Spinner,
  PanelHeader,
  ValidationError
} from "../components";
import { Select, ErrorIcon } from "../components/generic";

import { Toolbar } from "./toolbar";
import { ReportTable } from "./report_table";
import { ReportChart } from "./report_chart";
import { CsvDownload } from "./csv_download";

import {
  AGG_LEVELS,
  AGG_LEVEL,
  SELECTOR_TYPE,
  REQUEST_STATUS
} from "./_utils/constants";
import { DataTransformations } from "../../utils/data_transformations";
import ReportsDataTransformations from "./_utils/reportsDataTransformations";

import "./reports.css";

const { Sider, Content } = Layout;
const { Panel } = Collapse;

class Reports extends Component {
  state = {
    settings: {
      view: ButtonViewTypes.Table,
      aggLevel: AGG_LEVEL.STATIONS,
      startDt: moment()
        .add(-7, "days")
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),
      endDt: "",
      timeAggregation: "day",
      timePeriod: "1 w",
      [SELECTOR_TYPE.SERVICES]: {
        selectedItems: []
      },
      [SELECTOR_TYPE.VARIABLES]: {
        selectedItems: []
      },
      [SELECTOR_TYPE.OBJECTS]: {
        selectedItems: []
      },
      ...this.props.settings //override defaults with ones from server
    },
    tableWidth: 1000,
    tableHeight: 500,
    siderHeight: 500,
    page: {
      loading: true,
      error: false
    },
    requests: [],
    report: {
      data: []
    },
    selectedValues: {
      chartService: "",
      chartVariable: ""
    },
    services: {
      processed: []
    },
    variables: {
      processed: []
    },
    objects: {
      raw: [],
      processed: []
    },
    walkthrough: {
      show: false, //temp
      version: 0,
      steps: []
    }
  };

  fetchTimeAggregation() {
    return window.axiosClient.get("/time_aggregation");
  }

  fetchVariables() {
    return window.axiosClient.get("/variables");
  }

  fetchServices() {
    return window.axiosClient.get("/services");
  }

  fetchObjects() {
    return window.axiosClient.get("/core_objects?objectType=unit");
  }

  componentDidMount() {
    this.props.onLogAction("", "load", { state: this.state });
    const idToken = localStorage.getItem("id_token");
    //add id token before requests tp header
    window.axiosClient.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${idToken}`;

    //init load data
    const self = this;
    axios
      .all([
        this.fetchServices(),
        this.fetchVariables(),
        this.fetchObjects(),
        this.fetchTimeAggregation()
      ])
      .then(
        axios.spread(function(
          servicesResponse,
          variablesResponse,
          objectsResponse,
          timeAggResponse
        ) {
          self.setState(
            prevState => ({
              ...prevState,
              tableHeight: DataTransformations.getTableHeight(),
              tableWidth: DataTransformations.getTableWidth(),
              siderHeight: DataTransformations.getSiderHeight(),
              page: {
                ...prevState.page,
                loading: false
              },
              [SELECTOR_TYPE.SERVICES]: {
                ...prevState[SELECTOR_TYPE.SERVICES],
                raw: ReportsDataTransformations.sortServices(
                  servicesResponse.data
                ),
                processed: ReportsDataTransformations.getDataForSelectors(
                  SELECTOR_TYPE.SERVICES,
                  servicesResponse.data,
                  prevState.settings[SELECTOR_TYPE.SERVICES].selectedItems
                )
              },
              [SELECTOR_TYPE.VARIABLES]: {
                ...prevState[SELECTOR_TYPE.VARIABLES],
                raw: variablesResponse.data,
                processed: ReportsDataTransformations.getDataForSelectors(
                  SELECTOR_TYPE.VARIABLES,
                  variablesResponse.data,
                  prevState.settings[SELECTOR_TYPE.VARIABLES].selectedItems,
                  DataTransformations.getCheckedItems(
                    ReportsDataTransformations.getDataForSelectors(
                      SELECTOR_TYPE.SERVICES,
                      servicesResponse.data,
                      prevState.settings[SELECTOR_TYPE.SERVICES].selectedItems
                    )
                  )
                )
              },
              [SELECTOR_TYPE.OBJECTS]: {
                ...prevState[SELECTOR_TYPE.OBJECTS],
                raw: objectsResponse.data,
                processed: ReportsDataTransformations.getDataForSelectors(
                  SELECTOR_TYPE.OBJECTS,
                  objectsResponse.data,
                  prevState.settings[SELECTOR_TYPE.OBJECTS].selectedItems,
                  []
                )
              },
              timeAgg: {
                ...prevState.timeAgg,
                raw: timeAggResponse.data
              }
            }),
            () => self.updateState()
          );
        })
      )
      .catch(error => {
        console.error("Error occurred loading page", error);
        self.setState(prevState => ({
          page: {
            ...prevState.page,
            loading: false,
            error: true,
            "error-msg": error.message
          }
        }));
      });

    //on resize, reset table width and height
    window.onresize = () => {
      this.setState({
        tableHeight: DataTransformations.getTableHeight(),
        tableWidth: DataTransformations.getTableWidth(),
        siderHeight: DataTransformations.getSiderHeight()
      });
    };

    //add walkthrough steps
    const wSteps = [
      {
        title: "Services",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
        selector: ".services-selector-container",
        allowClicksThruHole: true,
        isFixed: false
        // style:{
        //     width: '500px'
        // }
      },
      {
        title: "Variables",
        text:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
        selector: ".variables-selector-container",
        allowClicksThruHole: true,
        isFixed: false
      }
    ];

    this.setState(prevState => ({
      walkthrough: {
        ...prevState.walkthrough,
        steps: wSteps
      }
    }));
  }

  logClickAction = (component, payload) => {
    this.props.onLogAction(component, "click", payload);
  };

  logFetchAction = (component, payload) => {
    this.props.onLogAction(component, "fetch", payload);
  };

  logError = (component, payload) => {
    this.props.onLogAction(component, "error", payload);
  };

  onRunReport = () => {
    const {
      services,
      variables,
      objects,
      settings: { aggLevel, startDt, endDt, timeAggregation }
    } = this.state;
    this.logClickAction("runReport", { settings: this.state.settings });
    const dtrange = `${startDt}-${endDt}`;

    const selectedObjectItems = this.state.settings.objects.selectedItems;

    const servicesFiltered = DataTransformations.getCheckedItems(
      services.processed
    );

    const variablesFiltered = DataTransformations.getCheckedItems(
      variables.processed
    );

    const serviceList = servicesFiltered
      .map(s => s.value)
      .join(",")
      .toLowerCase();
    const variableList = variablesFiltered.map(v => v.value).join(",");

    // const hierarchicalDataFiltered = DataTransformations.getHierarchicalData(
    //   this.state.objects.raw,
    //   servicesFiltered
    // );

    //reset state
    this.setState(prevState => ({
      report: {
        ...prevState.report,
        data: {
          ...prevState.report.data,
          [dtrange]: null
        }
      }
    }));
    const objectsChecked = DataTransformations.getCheckedItems(
      objects.processed
    );

    const objectsFiltered = ReportsDataTransformations.getObjectDataForReport(
      objectsChecked, // hierarchicalDataFiltered,
      aggLevel,
      selectedObjectItems,
      servicesFiltered,
      null,
      null
    );

    objectsFiltered.forEach(item => {
      this.fetchData(
        startDt,
        endDt,
        timeAggregation,
        serviceList,
        variableList,
        item.elements.join(",")
      );
    });
  };

  fetchData(
    startDt,
    endDt,
    groupByPeriod,
    serviceList,
    variableList,
    elementNoList
  ) {
    this.logFetchAction(
      "fetchData",
      startDt,
      endDt,
      groupByPeriod,
      serviceList,
      variableList,
      elementNoList
    );

    const self = this;
    const dtrange = `${startDt}-${endDt}`;
    //reset - should be done by parent before calling this function
    // self.setState(prevState => ({
    //   report: {
    //     ...prevState.report,
    //     data: {
    // 		...prevState.report.data,
    //     	[dtrange]: null
    // 	}
    //   }
    // }));

    let endpoints = {};
    const variables = variableList.split(",");
    const services = serviceList.split(",");
    const rawVariables = this.state.variables.raw;
    variables.forEach(v => {
      const fvs = rawVariables.filter(rv => rv.value === v);
      const fv = fvs && fvs.length > 0 ? fvs[0] : null;
      const vUrl = fv ? fv.fetchUrl : "";
      if (vUrl) {
        if (!endpoints[vUrl])
          endpoints[vUrl] = {
            variables: [],
            services: []
          };
        endpoints[vUrl].variables.push(v);
        services.forEach(s => {
          if (
            fv.services.indexOf(s) >= 0 &&
            endpoints[vUrl].services.indexOf(s) < 0
          )
            endpoints[vUrl].services.push(s); //add services that this variable endpoint supports
        });
      }
    });

    Object.keys(endpoints).forEach((eKey, i) => {
      let endpoint = "/" + eKey;
      let reportUrl = `${endpoint}?settStartDate=${encodeURIComponent(
        startDt
      )}&settEndDate=${encodeURIComponent(
        endDt
      )}&groupByPeriod=${groupByPeriod}&serviceList=${endpoints[
        eKey
      ].services.join(",")}&variableList=${endpoints[eKey].variables.join(
        ","
      )}&elementNoList=${encodeURIComponent(elementNoList)}`;

      // console.log(`Fetching ${i}: ${reportUrl}`);

      self.setState(prevState => ({
        requests: {
          ...prevState.requests,
          [reportUrl]: {
            ...prevState.requests[reportUrl],
            status: REQUEST_STATUS.LOADING
          }
        }
      }));

      //fetch from server
      window.axiosClient
        .get(reportUrl)
        .then(response => {
          //  console.log(`Received response for ${i}`, response);

          let data = Object.assign({}, self.state.report.data[dtrange]);
          if (!data[elementNoList]) data[elementNoList] = {};
          //if (!data[elementNoList]["reportData"]) data[elementNoList]["reportData"] = [];
          if (response && response.data) {
            //transform the array to object with settdt as key
            response.data.forEach(d => {
              const settDt = d["settlementdate"];
              if (!data[elementNoList][settDt])
                data[elementNoList][settDt] = {};
              Object.keys(d).forEach(k => {
                if (k !== "settlementdate")
                  data[elementNoList][settDt][k] = d[k];
              });
            });
          }
          self.setState(prevState => ({
            report: {
              ...prevState.report,
              data: {
                ...prevState.report.data,
                [dtrange]: data
              }
            },
            requests: {
              ...prevState.requests,
              [reportUrl]: {
                ...prevState.requests[reportUrl], //store data here if want to do caching.
                status: REQUEST_STATUS.SUCCESS
              }
            }
          }));
        })
        .catch(error => {
          const errorMsg = `Error fetching data for url: ${reportUrl}`;
          console.error(errorMsg, error);
          this.logError("fetchData", { errorMsg, error });

          // data[duidList]["error"] = true;//per duidlist i.e. api request
          // data[duidList]["error-msg"] = error.message;
          self.setState(prevState => ({
            report: {
              ...prevState.report,
              data: {
                ...prevState.report.data,
                [dtrange]: null
              }
            },
            requests: {
              ...prevState.requests,
              [reportUrl]: {
                ...prevState.requests[reportUrl],
                status: REQUEST_STATUS.ERROR
              }
            }
          }));
        });
    });
  }

  onFinishWalkthrough = (name, version) => {
    // console.log("finished walkthrough", name, version);
  };

  onChangeView = view => {
    this.logClickAction("view", { target: view });
    this.setState(
      prevState => ({
        settings: {
          ...prevState.settings,
          view: view
        }
      }),
      () => this.props.onUpdateSettings(this.state.settings)
    );
  };

  onTimePeriodUpdate = (
    startDt,
    endDt,
    timeAggregation,
    timePeriod,
    doUpdate
  ) => {
    const dtRange = `${startDt}-${endDt}`;
    this.setState(
      prevState => ({
        ...prevState,
        settings: {
          ...prevState.settings,
          startDt,
          endDt,
          timeAggregation,
          timePeriod
        },
        report: {
          ...prevState.report,
          data: {
            ...prevState.report.data,
            [dtRange]: null
          }
        }
      }),
      () => {
        this.props.onUpdateSettings(this.state.settings);
        if (doUpdate) this.onRunReport();
      }
    );
  };

  onChartServiceUpdate = value => {
    this.logClickAction("chartService", { target: value });

    this.setState(prevState => ({
      selectedValues: {
        ...prevState.selectedValues,
        chartService: value
      }
    }));
  };

  onChartVariableUpdate = value => {
    this.logClickAction("chartVariable", { target: value });

    this.setState(prevState => ({
      selectedValues: {
        ...prevState.selectedValues,
        chartVariable: value
      }
    }));
  };

  toggleCheckbox(selectorType, itemValue) {
    this.logClickAction("checkbox", {
      target: itemValue,
      selectorType: selectorType
    });

    const {
      [selectorType]: { raw },
      settings: { [selectorType]: { selectedItems } }
    } = this.state;

    const newSelectedItems = DataTransformations.toggleDeselectedItem(
      selectedItems,
      itemValue
    );

    const processed = ReportsDataTransformations.getDataForSelectors(
      selectorType,
      raw,
      newSelectedItems,
      DataTransformations.getCheckedItems(
        this.state[SELECTOR_TYPE.SERVICES].processed
      )
    );

    this.setState(
      prevState => ({
        settings: {
          ...prevState.settings,
          [selectorType]: {
            ...prevState.settings[selectorType],
            selectedItems: newSelectedItems
          }
        },
        [selectorType]: {
          ...prevState[selectorType],
          processed
        }
      }),
      () => {
        this.updateState();
        this.props.onUpdateSettings(this.state.settings);
      }
    );
  }

  toggleVariablesCheckbox = itemValue => () => {
    this.toggleCheckbox(SELECTOR_TYPE.VARIABLES, itemValue);
  };

  toggleServicesCheckbox = itemValue => () => {
    this.logClickAction("checkbox", {
      target: itemValue,
      selectorType: SELECTOR_TYPE.SERVICES
    });

    //SERVICES
    const newSelectedItems = DataTransformations.toggleDeselectedItem(
      this.state.settings[SELECTOR_TYPE.SERVICES].selectedItems,
      itemValue
    );

    const processedServices = ReportsDataTransformations.getDataForSelectors(
      SELECTOR_TYPE.SERVICES,
      this.state[SELECTOR_TYPE.SERVICES].raw,
      newSelectedItems,
      []
    );

    //VARIABLES, update based on changed checked services
    const processedVariables = ReportsDataTransformations.getDataForSelectors(
      SELECTOR_TYPE.VARIABLES,
      this.state[SELECTOR_TYPE.VARIABLES].raw,
      this.state.settings[SELECTOR_TYPE.VARIABLES].selectedItems,
      DataTransformations.getCheckedItems(processedServices)
    );

    //OBJECTS/ELEMENTS????
    //do nothing for now until decided

    this.setState(
      prevState => ({
        settings: {
          ...prevState.settings,
          [SELECTOR_TYPE.SERVICES]: {
            ...prevState.settings[SELECTOR_TYPE.SERVICES],
            selectedItems: newSelectedItems
          }
        },
        [SELECTOR_TYPE.SERVICES]: {
          ...prevState[SELECTOR_TYPE.SERVICES],
          processed: processedServices
        },
        [SELECTOR_TYPE.VARIABLES]: {
          ...prevState[SELECTOR_TYPE.VARIABLES],
          processed: processedVariables
        }
      }),
      () => {
        this.updateState();
        this.props.onUpdateSettings(this.state.settings);
      }
    );
  };

  toggleCheckboxes = selectorType => values => {
    this.logClickAction("checkboxes", {
      target: values,
      selectorType: selectorType
    });

    const processed = ReportsDataTransformations.getDataForSelectors(
      selectorType,
      this.state[selectorType].raw,
      values,
      DataTransformations.getCheckedItems(this.state.services.processed)
    );

    this.setState(
      prevState => ({
        settings: {
          ...prevState.settings,
          [selectorType]: {
            ...prevState.settings[selectorType],
            selectedItems: values
          }
        },
        [selectorType]: {
          ...prevState[selectorType],
          processed: processed
        }
      }),
      () => {
        this.updateState();
        this.props.onUpdateSettings(this.state.settings);
      }
    );
  };

  onUpdateObjectsAggLevel = aggLevel => {
    this.logClickAction("objectAggLevel", { target: aggLevel });
    this.setState(
      prevState => ({
        settings: {
          ...prevState.settings,
          aggLevel: aggLevel
        }
      }),
      () => this.props.onUpdateSettings(this.state.settings)
    );
  };

  updateState = () => {
    const { services, variables, objects } = this.state;
    //  console.log("UPDATE STATE INVOKED", this.state);

    //ELEMENTS
    const objectsChecked = objects.processed
      ? DataTransformations.getCheckedItems(objects.processed)
      : [];

    const objectsValidationError =
      objectsChecked.length < 1 ? "Please select an element" : "";

    //SERVICES
    const servicesChecked = services.processed
      ? DataTransformations.getCheckedItems(services.processed)
      : [];

    const servicesValidationError =
      servicesChecked.length < 1 ? "Please select a service" : "";

    //VARIABLES
    const variablesFiltered =
      variables.processed && servicesChecked
        ? ReportsDataTransformations.getFilteredVariables(
            variables.processed,
            variables.raw,
            servicesChecked
          )
        : [];

    const variablesFilteredChecked = DataTransformations.getCheckedItems(
      variablesFiltered
    );
    const variablesValidationError =
      variablesFilteredChecked.length < 1
        ? "Please select an active variable"
        : "";

    this.setState(prevState => ({
      objects: {
        ...prevState.objects,
        checked: objectsChecked,
        validationError: objectsValidationError
      },
      services: {
        ...prevState.services,
        checked: servicesChecked,
        validationError: servicesValidationError
      },
      variables: {
        ...prevState.variables,
        filtered: variablesFiltered,
        checked: variablesFilteredChecked,
        validationError: variablesValidationError
      }
    }));
  };

  render() {
    const {
      tableWidth,
      tableHeight,
      services,
      variables,
      objects,
      requests,
      settings: { view, aggLevel, startDt, endDt, timeAggregation, timePeriod }
    } = this.state;

    //  console.log("REPORTS RENDER STATE", this.state);

    let { selectedValues: { chartService, chartVariable } } = this.state;

    if (!chartService && services.checked && services.checked.length > 0)
      chartService = services.checked[0].value;

    if (!chartVariable && variables.checked && variables.checked.length > 0)
      chartVariable = variables.checked[0].value;

    const selectedObjectItems = this.state.settings.objects.selectedItems;
    const dtRange = `${startDt}-${endDt}`;
    const reportData = this.state.report.data[dtRange];
    const objectsFiltered = ReportsDataTransformations.getObjectDataForReport(
      objects.checked,
      aggLevel,
      selectedObjectItems,
      services.checked,
      variables.checked,
      reportData,
      this.state.variables.raw
    );

    //chart plots only one service and one variable at a time
    const chartObjectsFiltered = ReportsDataTransformations.getObjectDataForReport(
      objects.checked,
      aggLevel,
      selectedObjectItems,
      null,
      null,
      reportData,
      this.state.variables.raw
    );

    const isLoading =
      Object.keys(requests).filter(
        i => requests[i].status === REQUEST_STATUS.LOADING
      ).length > 0;

    const hasErrors =
      Object.keys(requests).filter(
        i => requests[i].status === REQUEST_STATUS.ERROR
      ).length > 0;

    // console.log(
    //   "Layout render objects filtered with data ",
    //   //      objectsFiltered,
    //   //chartObjectsFiltered,
    //   this.state,
    //
    // );
    return (
      <div className="cp-report-layout test-reports">
        {this.state.page.loading ? (
          <Spinner className="page-loader" />
        ) : this.state.page.error ? (
          <ErrorIcon
            className="page-error"
            message="An error occurred while loading the page, try reloading (Ctrl + F5). If error persists, contact pdView."
          />
        ) : (
          <Layout>
            {this.state.walkthrough.show && (
              <Walkthrough
                name="reports"
                version={this.state.walkthrough.version}
                steps={this.state.walkthrough.steps}
                onFinishWalkthrough={this.onFinishWalkthrough}
              />
            )}
            <Sider
              width={320}
              style={{
                padding: "10px",
                background: "#dedede",
                overflowY: "scroll",
                height: "100vh"
                // position: "fixed",
                // left: 0
              }}
              className={"test-sider"}
            >
              <Collapse bordered={true} defaultActiveKey={["1", "2", "3"]}>
                <Panel
                  header={
                    <PanelHeader
                      heading={"ELEMENTS"}
                      errorMessage={objects.validationError}
                    />
                  }
                  key={3}
                  className={"test-panel"}
                >
                  <SelectorDuid
                    items={objects.processed}
                    onToggleItems={this.toggleCheckboxes(SELECTOR_TYPE.OBJECTS)}
                  />
                </Panel>
                <Panel
                  header={
                    <PanelHeader
                      heading={"SERVICES"}
                      errorMessage={services.validationError}
                    />
                  }
                  key={1}
                  className={"test-panel"}
                >
                  <Selector
                    items={services.processed}
                    onClick={this.toggleServicesCheckbox}
                  />
                </Panel>
                <Panel
                  header={
                    <PanelHeader
                      heading={"VARIABLES"}
                      errorMessage={variables.validationError}
                    />
                  }
                  key={2}
                  className={"test-panel"}
                >
                  <Selector
                    items={variables.processed}
                    onClick={this.toggleVariablesCheckbox}
                  />
                </Panel>
              </Collapse>
            </Sider>
            <Content style={{ padding: "10px" }}>
              <Toolbar
                onUpdateTimePeriod={this.onTimePeriodUpdate}
                onUpdateObjectAggregation={this.onUpdateObjectsAggLevel}
                startDateTime={startDt}
                timeAggregationOptions={this.state.timeAgg.raw}
                timeAggregation={this.state.settings.timeAggregation}
                objectAggregationOptions={AGG_LEVELS}
                objectAggregation={aggLevel}
                timePeriod={timePeriod}
              />
              <div className="report-bar test-report-bar">
                {hasErrors && <RequestError />}
                <Form layout="inline">
                  <Form.Item label="View">
                    <ButtonViews
                      onClick={this.onChangeView}
                      selectedView={view}
                    />
                  </Form.Item>
                  {view === ButtonViewTypes.Chart &&
                    services.checked &&
                    services.checked.length > 0 &&
                    variables.checked &&
                    variables.checked.length > 0 && (
                      <span>
                        <Form.Item label="Service">
                          <Select
                            style={{ width: "120px" }}
                            options={services.checked}
                            selectedValue={chartService}
                            onChange={this.onChartServiceUpdate}
                          />
                        </Form.Item>
                        <Form.Item label="Variable">
                          <Select
                            style={{ width: "240px" }}
                            options={variables.checked}
                            selectedValue={chartVariable}
                            onChange={this.onChartVariableUpdate}
                          />
                        </Form.Item>
                      </span>
                    )}
                  {objectsFiltered &&
                    objectsFiltered.length > 0 && (
                      <Form.Item label="">
                        <CsvDownload
                          className="csv-download"
                          // style={{ marginTop: "7px" }}
                          objectData={objectsFiltered}
                        />
                      </Form.Item>
                    )}
                </Form>
              </div>
              {(objects.validationError ||
                services.validationError ||
                variables.validationError) && (
                <ValidationError>
                  {objects.validationError && (
                    <div>
                      <b>ELEMENTS:</b> {objects.validationError}
                    </div>
                  )}
                  {services.validationError && (
                    <div>
                      <b>SERVICES:</b> {services.validationError}
                    </div>
                  )}
                  {variables.validationError && (
                    <div>
                      <b>VARIABLES:</b> {variables.validationError}
                    </div>
                  )}
                </ValidationError>
              )}

              <section className="report">
                {view === ButtonViewTypes.Chart &&
                  services.checked &&
                  services.checked.length > 0 &&
                  variables.checked &&
                  variables.checked.length > 0 && (
                    <div className="report-chart-container">
                      {chartVariable &&
                        chartService && (
                          <ReportChart
                            loading={isLoading}
                            aggLevel={aggLevel}
                            data={chartObjectsFiltered}
                            chartWidth={tableWidth}
                            chartHeight={tableHeight}
                            timeAggregation={timeAggregation}
                            startDt={startDt}
                            endDt={endDt}
                            variable={
                              variables.processed.filter(
                                v => v.value === chartVariable
                              )[0]
                            }
                            service={
                              services.processed.filter(
                                s => s.value === chartService
                              )[0]
                            }
                          />
                        )}
                    </div>
                  )}
                {view === ButtonViewTypes.Table && (
                  <div className="report-table-container">
                    <ReportTable
                      loading={isLoading}
                      timeAgg={
                        this.state.timeAgg &&
                        this.state.timeAgg.raw.filter(
                          t => t.value === timeAggregation
                        )[0]
                      }
                      aggLevel={aggLevel}
                      data={objectsFiltered}
                      tableWidth={tableWidth}
                      tableHeight={tableHeight}
                    />
                  </div>
                )}
              </section>
              {/*<Footer />*/}
            </Content>
          </Layout>
        )}
      </div>
    );
  }
}

Reports.propTypes = {
  onLogAction: PropTypes.func.isRequired,
  onUpdateSettings: PropTypes.func.isRequired,
  settings: PropTypes.object
};

export default Reports;



// WEBPACK FOOTER //
// ./src/views/reports/Reports.jsx